import React from "react";

// Minimal stroke-based icon set shared by VendorCard and VendorDetailsModal.
// Keeping these local (rather than emoji or a font-icon set) means the
// admin UI reads consistently at any size and doesn't depend on the
// OS emoji font rendering differently across machines.

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const IconTrash = (props) => (
  <svg {...base} width={16} height={16} {...props}>
    <path d="M4 7h16" />
    <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
    <path d="M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
  </svg>
);

export const IconPencil = (props) => (
  <svg {...base} width={16} height={16} {...props}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </svg>
);

export const IconChevronRight = (props) => (
  <svg {...base} width={16} height={16} {...props}>
    <path d="M9 6l6 6-6 6" />
  </svg>
);

export const IconClose = (props) => (
  <svg {...base} width={16} height={16} {...props}>
    <path d="M6 6l12 12" />
    <path d="M18 6L6 18" />
  </svg>
);

export const IconCheckCircle = (props) => (
  <svg {...base} width={16} height={16} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M8.5 12.4l2.3 2.3 4.7-5" />
  </svg>
);

export const IconClock = (props) => (
  <svg {...base} width={16} height={16} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.5v5l3.2 1.8" />
  </svg>
);

export const IconAlertTriangle = (props) => (
  <svg {...base} width={16} height={16} {...props}>
    <path d="M12 4.5 3 20h18Z" />
    <path d="M12 10.5v4" />
    <path d="M12 17.2h.01" />
  </svg>
);

export const IconMinusCircle = (props) => (
  <svg {...base} width={16} height={16} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M8 12h8" />
  </svg>
);

export const IconExternalLink = (props) => (
  <svg {...base} width={16} height={16} {...props}>
    <path d="M14 4h6v6" />
    <path d="M10 14 20 4" />
    <path d="M19 13v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
  </svg>
);

export const IconInstagram = (props) => (
  <svg {...base} width={16} height={16} {...props}>
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.3" cy="6.7" r="0.6" fill="currentColor" stroke="none" />
  </svg>
);

export const IconFacebook = (props) => (
  <svg {...base} width={16} height={16} {...props}>
    <path d="M14.5 9.2H17V6h-2.5A3.3 3.3 0 0 0 11.2 9.3v1.9H9v3h2.2V21h3v-6.8h2.3l.5-3h-2.8V9.6c0-.3.2-.4.3-.4Z" />
  </svg>
);